/* PAPPOS — aviso «cupón aplicado»: aviso al llegar + estado del cupón en el carrito lateral.
   Lee /cart.js (discount_codes). Configuración en window.ppCoupon (sección pp-coupon). */
(() => {
  const cfg = window.ppCoupon;
  if (!cfg || !cfg.codes) return;
  const KNOWN = cfg.codes;
  const SEEN = 'pp_cpn_seen';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isShip = (name) => /env[ií]o\s+gratis/i.test(name || '');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  const CHECK_SM = CHECK.replace(/16/g, '12');
  const CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  let cartTotal = 0;
  const money = (cents) => '$ ' + (Math.ceil(cents) / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  let pending = null;
  function getCart() {
    if (!pending) {
      pending = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null)
        .finally(() => { setTimeout(() => { pending = null; }, 0); });
    }
    return pending;
  }

  /* Monto mínimo escrito en la condición («desde $679»), en centavos. Shopify marca los cupones de envío
     como aplicables aunque no se llegue al mínimo, así que el mínimo se revisa aquí. */
  const minOf = (rule) => {
    const m = String(rule || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d+)?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  };

  /* Cupones del carrito. Con carrito vacío Shopify marca todo como «no aplica», así que solo se confía en los de la lista. */
  function read(cart) {
    const empty = !cart || cart.item_count === 0;
    const total = (cart && cart.total_price) || 0;
    return ((cart && cart.discount_codes) || []).map((d) => {
      const code = String(d.code || '').toUpperCase();
      const k = KNOWN[code];
      const ok = !!d.applicable && !empty && (!k || total >= minOf(k.rule));
      return { code, known: !!k, name: k ? k.name : code, rule: k ? k.rule : '', ok, waiting: empty && !!k };
    }).filter((x) => x.known || x.ok);
  }

  function toast(list) {
    const show = list.filter((x) => x.known && (x.ok || x.waiting));
    if (!show.length) return;
    const key = show.map((x) => x.code).sort().join(',');
    try {
      if (sessionStorage.getItem(SEEN) === key) return;
      sessionStorage.setItem(SEEN, key);
    } catch (e) { /* modo privado: se muestra igual */ }
    const el = document.createElement('div');
    el.className = 'pp-cpn';
    el.setAttribute('role', 'status');
    const names = show.map((x) => esc(x.name) + (!x.ok && minOf(x.rule) > 0 ? ' desde ' + money(minOf(x.rule)) : '')).join(' + ');
    el.innerHTML = '<span class="pp-cpn__ic">' + CHECK + '</span>' +
      '<div class="pp-cpn__tx"><strong>' + esc(cfg.title) + '</strong><span>' + names.charAt(0).toUpperCase() + names.slice(1) + (cfg.sub ? '. ' + esc(cfg.sub) : '') + '</span></div>' +
      '<button type="button" class="pp-cpn__x" aria-label="Cerrar aviso">' + CLOSE + '</button>';
    document.body.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-on')));
    let timer;
    const close = () => { clearTimeout(timer); el.classList.remove('is-on'); setTimeout(() => el.remove(), 350); };
    el.querySelector('.pp-cpn__x').addEventListener('click', close);
    timer = setTimeout(close, 9000);
    el.addEventListener('mouseenter', () => clearTimeout(timer));
    el.addEventListener('focusin', () => clearTimeout(timer));
  }

  function paintDrawer(list) {
    const panel = document.querySelector('#pp-cart .pp-drawer__panel');
    const foot = panel && panel.querySelector('.pp-drawer__foot');
    if (!foot) return; /* carrito vacío */
    let box = foot.querySelector('[data-pp-cpns]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'pp-cpns';
      box.setAttribute('data-pp-cpns', '');
      box.setAttribute('role', 'status');
      foot.insertBefore(box, foot.firstChild);
    }
    const ok = list.filter((x) => x.ok);
    const no = list.filter((x) => !x.ok && x.known);
    box.innerHTML =
      ok.map((x) => '<span class="pp-cpns__ok">' + CHECK_SM + '<b>' + esc(x.code) + '</b>' + (x.known ? esc(x.name) : 'aplicado') + '</span>').join('') +
      no.map((x) => '<span class="pp-cpns__no"><b>' + esc(x.code) + '</b>' + (x.rule ? esc(x.rule.charAt(0).toLowerCase() + x.rule.slice(1)) : 'aún no aplica') + '</span>').join('');
    box.hidden = !box.innerHTML;
    const note = foot.querySelector('.pp-note');
    if (note) note.hidden = ok.length > 0;

    /* Cupón de envío gratis aplicado: que el carrito no diga «te faltan $X para envío gratis». */
    if (ok.some((x) => x.known && isShip(x.name))) {
      foot.querySelectorAll('.pp-sum').forEach((row) => {
        const [label, val] = row.children;
        if (label && val && /env[ií]o/i.test(label.textContent) && !val.classList.contains('is-free')) {
          val.textContent = cfg.shipFree || 'Gratis';
          val.classList.add('is-free');
        }
      });
      const bar = panel.querySelector('.pp-ship');
      if (bar && !bar.classList.contains('is-done')) {
        bar.classList.add('is-done');
        const txt = bar.querySelector('span');
        if (txt) txt.textContent = 'Tu envío es gratis con tu cupón';
        const fill = bar.querySelector('.pp-ship__bar span');
        if (fill) fill.style.width = '100%';
      }
      const up = panel.querySelector('.pp-up h3');
      if (up) up.textContent = 'Completa tu compra';
      return;
    }

    /* Cupón de envío gratis con mínimo menor al envío gratis normal: el carrito cuenta contra el mínimo del cupón. */
    const shipWait = no.find((x) => isShip(x.name) && minOf(x.rule) > 0);
    const bar = panel.querySelector('.pp-ship');
    if (shipWait && bar && !bar.classList.contains('is-done') && cartTotal < minOf(shipWait.rule)) {
      const min = minOf(shipWait.rule);
      const left = money(min - cartTotal);
      const txt = bar.querySelector('span');
      if (txt) txt.innerHTML = 'Te faltan <b>' + left + '</b> para envío gratis con tu cupón';
      const fill = bar.querySelector('.pp-ship__bar span');
      if (fill) fill.style.width = Math.min(100, Math.round((cartTotal / min) * 100)) + '%';
      const up = panel.querySelector('.pp-up h3');
      if (up) up.textContent = 'Agrega ' + left + ' o más y tu cupón te da envío gratis';
    }
  }

  async function run(first) {
    const cart = await getCart();
    if (!cart) return;
    cartTotal = cart.total_price || 0;
    const list = read(cart);
    paintDrawer(list);
    if (first) toast(list);
  }

  /* El carrito lateral se vuelve a pintar (Section Rendering) al agregar o cambiar cantidades. */
  const panel = document.querySelector('#pp-cart .pp-drawer__panel');
  if (panel && 'MutationObserver' in window) {
    let t;
    new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => run(false), 50); }).observe(panel, { childList: true });
  }
  run(true);
})();
